import { render } from "./ActivateCampaignAction.vue?vue&type=template&id=86e49e78"
import script from "./ActivateCampaignAction.vue?vue&type=script&lang=ts"
export * from "./ActivateCampaignAction.vue?vue&type=script&lang=ts"
script.render = render

export default script